const l = "_inlineFlex_13waq_1", e = "_flex_13waq_6", n = "_fullWidth_13waq_11", t = {
  inlineFlex: l,
  flex: e,
  fullWidth: n
};
export {
  t as default,
  e as flex,
  n as fullWidth,
  l as inlineFlex
};
//# sourceMappingURL=Flex.module.css.js.map
